module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="objects-listing is-viewmode-slider">\n    <div class="container sly-frame">\n        <div class="list list-flex sly-slider objects-slider-container"></div>\n    </div>\n\n    <div class="sly-scroll"><div class="sly-scroll-handle"></div></div>\n</div>';
}
return __p;
};